import React from 'react';
import PropTypes from 'prop-types';

import EmployerNavigationRebrand from '../EmployerNavigation/EmployerNavigationRebrand';

const NavigationHeader = ({ showAccountSwitcher, showProfileMenu, showSidebar, showSecondaryNavigation, onClickBack, backTitle }) => (
  <EmployerNavigationRebrand
    className="baseNavigation"
    showAccountSwitcher={showAccountSwitcher}
    showProfileMenu={showProfileMenu}
    showSidebar={showSidebar}
    showSecondaryNavigation={showSecondaryNavigation}
    onClickBack={onClickBack}
    backTitle={backTitle}
  />
);

NavigationHeader.propTypes = {
  showAccountSwitcher: PropTypes.bool,
  showProfileMenu: PropTypes.bool,
  showSidebar: PropTypes.bool,
  showSecondaryNavigation: PropTypes.bool,
  onClickBack: PropTypes.func,
  backTitle: PropTypes.string,
};

NavigationHeader.defaultProps = {
  showAccountSwitcher: true,
  showProfileMenu: true,
  showSidebar: true,
  showSecondaryNavigation: false,
  onClickBack: null,
  backTitle: null,
};

export default NavigationHeader;
